import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "./Reviews.css";
import { useTranslation } from "react-i18next";
import AuthContext from "../contexts/AuthProvider";

import { API_URL } from "../utils/config";
const baseUrl = API_URL;

const Reviews = () => {
  const { t } = useTranslation("place");

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState({});
const { isAuthenticated } = useContext(AuthContext);
  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  const fetchReviews = async () => {
    try {
      if (!isAuthenticated) {
        localStorage.removeItem("token");
         
        navigate("/");
        return [];
      }

      const response = await fetch(
        `${baseUrl}/api/v1/attnd-venue/myVenues/reviews`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),
          },
        }
      );

      if (response.status === 401) {
        localStorage.removeItem("token");
         
        navigate("/login");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch reviews");
      }

      const reviews = await response.json();
      return reviews;
    } catch (error) {
      console.error("Error fetching reviews:", error);
      return [];
    }
  };

  useEffect(() => {
    const getReviews = async () => {
      setLoading(true);
      const reviews = await fetchReviews();
      setReviews(reviews || {});
      setLoading(false);
    };
    getReviews();
  }, []);

  if (loading) {
    return (
      <div className="reviews-loader-container">
        <Loader />
      </div>
    );
  }

  return (
    <div className="reviews-main-content">
      <div className="reviews-header">
        <h2 className="reviews-heading">{t("ReviewsPage.title")}</h2>
        <p className="reviews-desc">{t("ReviewsPage.description")}</p>
        <div className="reviews-stats">
          <div className="total-reviews">
            <h4>{t("ReviewsPage.totalReviews")}</h4>
            <span>{reviews?.data?.totalReviews || 0}</span>
            <p>{t("ReviewsPage.customerReviewsLabel")}</p>
          </div>
          <div className="avg-review">
            <h4>{t("ReviewsPage.averageRatings")}</h4>
            <div className="avg-rating">
              <span className="avg-number">
                {reviews?.data?.averageRating || 0}
              </span>
              <div className="rating-icons">
                {Array.from({ length: 5 }, (_, index) => {
                  const starIndex = index + 1;
                  const stars = reviews?.data?.averageRating || 0;

                  // Full star
                  if (starIndex <= Math.floor(stars)) {
                    return <img key={index} src="/star.svg" alt="star icon" />;
                  }

                  // Half star - check if we have a decimal part >= 0.5
                  if (starIndex === Math.floor(stars) + 1 && stars % 1 >= 0.5) {
                    return (
                      <svg
                        key={index}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <defs>
                          <linearGradient
                            id={`half-star-${index}`}
                            x1="0"
                            x2="100%"
                            y1="0"
                            y2="0"
                          >
                            <stop offset="50%" stopColor="#EF5A29" />
                            <stop offset="50%" stopColor="#888888" />
                          </linearGradient>
                        </defs>
                        <path
                          d="M11.0489 2.92705C11.3483 2.00574 12.6517 2.00574 12.9511 2.92705L14.4697 7.60081C14.6035 8.01284 14.9875 8.2918 15.4207 8.2918H20.335C21.3037 8.2918 21.7065 9.53141 20.9228 10.1008L16.947 12.9894C16.5966 13.244 16.4499 13.6954 16.5838 14.1074L18.1024 18.7812C18.4017 19.7025 17.3472 20.4686 16.5635 19.8992L12.5878 17.0106C12.2373 16.756 11.7627 16.756 11.4122 17.0106L7.43648 19.8992C6.65276 20.4686 5.59828 19.7025 5.89763 18.7812L7.41623 14.1074C7.55011 13.6954 7.40345 13.244 7.05296 12.9894L3.07722 10.1008C2.29351 9.53141 2.69628 8.2918 3.66501 8.2918H8.57929C9.01252 8.2918 9.39647 8.01284 9.53035 7.60081L11.0489 2.92705Z"
                          fill={`url(#half-star-${index})`}
                        />
                      </svg>
                    );
                  }

                  // Empty star
                  return (
                    <svg
                      key={index}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.0489 2.92705C11.3483 2.00574 12.6517 2.00574 12.9511 2.92705L14.4697 7.60081C14.6035 8.01284 14.9875 8.2918 15.4207 8.2918H20.335C21.3037 8.2918 21.7065 9.53141 20.9228 10.1008L16.947 12.9894C16.5966 13.244 16.4499 13.6954 16.5838 14.1074L18.1024 18.7812C18.4017 19.7025 17.3472 20.4686 16.5635 19.8992L12.5878 17.0106C12.2373 16.756 11.7627 16.756 11.4122 17.0106L7.43648 19.8992C6.65276 20.4686 5.59828 19.7025 5.89763 18.7812L7.41623 14.1074C7.55011 13.6954 7.40345 13.244 7.05296 12.9894L3.07722 10.1008C2.29351 9.53141 2.69628 8.2918 3.66501 8.2918H8.57929C9.01252 8.2918 9.39647 8.01284 9.53035 7.60081L11.0489 2.92705Z"
                        fill="#888888"
                      />
                    </svg>
                  );
                })}
              </div>
            </div>
            <p>{t("ReviewsPage.averageCustomerRatings")}</p>
          </div>
          <div className="review-rating">
            <div style={{ width: "185px" }}>
              <div className="five-stars">
                <img
                  className="empty-rating-icon"
                  src="/Star 1.svg"
                  alt="star icon"
                />
                <span>5</span>
                <div className="five-star-bar"></div>
                <span>{reviews?.data?.ratingBreakdown["5"] || 0}</span>
              </div>
              <div className="four-stars">
                <img
                  className="empty-rating-icon"
                  src="/Star 1.svg"
                  alt="star icon"
                />
                <span>4</span>
                <div className="four-star-bar"></div>
                <span>{reviews?.data?.ratingBreakdown["4"] || 0}</span>
              </div>
              <div className="three-stars">
                <img
                  className="empty-rating-icon"
                  src="/Star 1.svg"
                  alt="star icon"
                />
                <span>3</span>
                <div className="three-star-bar"></div>
                <span>{reviews?.data?.ratingBreakdown["3"] || 0}</span>
              </div>
              <div className="two-stars">
                <img
                  className="empty-rating-icon"
                  src="/Star 1.svg"
                  alt="star icon"
                />
                <span>2</span>
                <div className="two-star-bar"></div>
                <span>{reviews?.data?.ratingBreakdown["2"] || 0}</span>
              </div>
              <div className="one-stars">
                <img
                  className="empty-rating-icon"
                  src="/Star 1.svg"
                  alt="star icon"
                />
                <span>1</span>
                <div className="one-star-bar"></div>
                <span>{reviews?.data?.ratingBreakdown["1"] || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {reviews?.reviews?.length > 0 && (
        <div className="reviewers-content">
          <h3 className="all-reviews">All Reviews</h3>
          <div className="reviewers">
            {reviews?.reviews.map((review, index) => {
              return (
                <div className="reviewer-card" key={index}>
                  <div className="reviewer-info">
                    {review?.user?.image ? (
                      <img src={`${review?.user?.image}`} alt="reviewer" />
                    ) : (
                      <img src="/reviewer.svg" alt="reviewer" />
                    )}
                    <p>{review?.user?.fullName}</p>
                  </div>
                  <div className="reviewer-rate">
                    <div className="reviewer-rate-content">
                      <div className="rate-icons">
                        {Array.from({ length: 5 }, (_, index) => {
                          const starIndex = index + 1;
                          const rating = review?.rating || 0;

                          // Filled star
                          if (starIndex <= rating) {
                            return (
                              <img
                                key={index}
                                src="/star.svg"
                                alt="star icon"
                              />
                            );
                          }

                          // Empty star
                          return (
                            <svg
                              key={index}
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0489 2.92705C11.3483 2.00574 12.6517 2.00574 12.9511 2.92705L14.4697 7.60081C14.6035 8.01284 14.9875 8.2918 15.4207 8.2918H20.335C21.3037 8.2918 21.7065 9.53141 20.9228 10.1008L16.947 12.9894C16.5966 13.244 16.4499 13.6954 16.5838 14.1074L18.1024 18.7812C18.4017 19.7025 17.3472 20.4686 16.5635 19.8992L12.5878 17.0106C12.2373 16.756 11.7627 16.756 11.4122 17.0106L7.43648 19.8992C6.65276 20.4686 5.59828 19.7025 5.89763 18.7812L7.41623 14.1074C7.55011 13.6954 7.40345 13.244 7.05296 12.9894L3.07722 10.1008C2.29351 9.53141 2.69628 8.2918 3.66501 8.2918H8.57929C9.01252 8.2918 9.39647 8.01284 9.53035 7.60081L11.0489 2.92705Z"
                                fill="#888888"
                              />
                            </svg>
                          );
                        })}
                      </div>
                      <p className="rate-date">
                        {review?.created_at
                          ? (() => {
                              const date = new Date(review.created_at);
                              const day = String(date.getDate()).padStart(
                                2,
                                "0"
                              );
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, "0");
                              const year = date.getFullYear();
                              return `${day}-${month}-${year}`;
                            })()
                          : "No date"}
                      </p>
                    </div>
                    <p className="rate-comment">{review?.message}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Reviews;
